import React, { useState, useEffect } from "react";
import vcdms from "../../../assets/rcc-version-logo.png";
import "../versions/version.css";
import packageVersion from "../../../../package.json";
import httpService from "../../../services/http.service";
import ErrorMessage from "../../common/errorMsg";

const Version = () => {
  const [backendVersion, setbackendVersion] = useState("");
  const [property, setProperty] = useState({ NoOfProperty: "", UsedProperty: "" })
  // const [property, setProperty] = useState("")

  useEffect(async () => {
    async function fetchData() {
      let returndata = await httpService.get("getbackendversion").then(
        (res) => res.data
      )
        .catch((err) => {
          if (err && err.response && err.response.status === 401) {
            ErrorMessage("Session expired, please login again")
          }
          return
        });
      let license = await httpService.get('getlicenses').then(res => res.data)
      setProperty({ NoOfProperty: license.output.NumberOfLicence, UsedProperty: license.UsedProperty })
      setbackendVersion(returndata);
    }
    fetchData()
  }, []);

  return (
    <div>
      <div className="pad-15" style={{ margin: "20px" }}>
        <div className="form-boxdiv">
          <div className="form-boxtopline5">About</div>
          <div className="form-boxtopcont">
            <div className="form-boxdiv-gray">
              <div className="form-boxtopcont user-form">
                <div className=" panel-default">
                  <div className="panel-body">
                    <div className="row">
                      <div className="col-sm-2">
                        <figure className="rcc-version-logo">
                          <img src={vcdms} />
                        </figure>
                        <div className="rcc-version">
                          <h5 style={{ fontSize: "15px" }}>Radiant Stream Director Customer Portal </h5>
                          <h5 style={{ fontSize: "15px" }}>UI/UX Version :- <span>{packageVersion.version}</span></h5>
                          <h5 style={{ fontSize: "15px" }}>Backend Version :- <span>{backendVersion}</span></h5>
                          {/* <h5 style={{ fontSize: "14px" }}>Total No. of Licensed Property Used :- <span>{property.UsedProperty}</span></h5> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Version;
